/*
 * @Description: 试用期绩效考核审批
 * @Author: 杨志航
 * @Date: 2026-01-22 15:20:06
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'
import Main from './Main'
import Detail from './Detail'
import SaleTemplate from './SaleTemplate'

const ProbationAchAudit = ({ match, history }) => {

  return (
    <CacheSwitch>
      <Route path={match.path + '/detail'} component={Detail} />
      <Route path={match.path + '/saletemplate'} component={SaleTemplate} />
      <CacheRoute component={Main} />
    </CacheSwitch>
  )
}

export default ProbationAchAudit